import { combineReducers } from 'redux'
import uniqueAiObjectsDialogState from './uniqueAiObjectsDialogState'

export default combineReducers({
  uniqueAiObjectsDialogState,
})
